let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fZuo0")).then(() => parcelRequire('3OMEX'));